/** Display name of a provider id such as `claude-platform`. */
export const formatProviderName = (provider: string): string =>
  provider
    .split(/[-_]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
